import { useCallback, useMemo } from 'react';
import { endOfMonth, format, startOfMonth } from 'date-fns';
import { useSetting } from '../../core/hooks';
import { DATE_FORMAT } from '../../core/constants';

interface Filters {
  startDate: Date;
  endDate: Date;
  categoryId: string | undefined;
}

type SetFilters = (next: Partial<Filters>) => void;
export const useTransactionFilters = (): [Filters, SetFilters] => {
  const [startDateSetting, setStartDate] = useSetting('startDate');
  const [categoryId, setCategoryId] = useSetting('categoryId');

  const filters = useMemo(() => {
    const startDate = startDateSetting ? new Date(startDateSetting) : startOfMonth(new Date());
    return {
      startDate,
      endDate: endOfMonth(startDate),
      categoryId: categoryId ?? undefined,
    };
  }, [startDateSetting, categoryId]);

  const setFilters = useCallback(
    (next: Partial<Filters>): void => {
      if (next.startDate) {
        setStartDate(format(next.startDate, DATE_FORMAT));
      }
      if (next.categoryId) {
        setCategoryId(next.categoryId);
      }
    },
    [setStartDate, setCategoryId],
  );

  return [filters, setFilters];
};
